import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { eramanCMSApi } from "~/Services";

interface PromotionsBanner {
  id: string;
  name: string;
  image: string;
  field_english_title: string;
  field_malay_title: string;
  field_mandarin_title: string;
  published: boolean;
}

interface BrandsBanner {
  id: number;
  name: string;
  field_english_title: string;
  field_malay_title: string;
  field_mandarin_title: string;
  field_beauty_image: string;
  field_confectionary_image: string;
  field_wine_spirits_image: string;
  published: boolean;
}

interface TopSellingBanner {
  id: number;
  name: string;
  image: string;
  field_english_title: string;
  field_malay_title: string;
  field_mandarin_title: string;
  published: string;
}

interface NewsBanner {
  tid: string;
  name: string;
  field_english_title: string;
  field_malay_title: string;
  field_mandarin_title: string;
  published: string;
}

// Promotion get api
const fetchAdsPromotionDetails = async (id: string): Promise<any> => {
  const response: any = await eramanCMSApi.get(`/api/prmotions-products-banner-data`);
  return response.data[0];
};

const useAdsPromotionDocumentDetails = (
  id: string,
  options?: UseQueryOptions<PromotionsBanner, DefaultError, PromotionsBanner, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<PromotionsBanner, DefaultError> => {
  return useQuery<PromotionsBanner, DefaultError, PromotionsBanner, QueryKey>(
    {
      queryKey: ["adsPromotionDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchAdsPromotionDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

//Brand get api
const fetchAdsBrandDetails = async (id: string): Promise<any> => {
  const response: any = await eramanCMSApi.get(`/api/get-brands/all`);
  return response.data[0];
};

const useAdsBrandDocumentDetails = (
  id: string,
  options?: UseQueryOptions<BrandsBanner, DefaultError, BrandsBanner, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<BrandsBanner, DefaultError> => {
  return useQuery<BrandsBanner, DefaultError, BrandsBanner, QueryKey>(
    {
      queryKey: ["adsBrandDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchAdsBrandDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

//Top Selling get api
const fetchAdsTopSellingDetails = async (id: string): Promise<any> => {
  const response: any = await eramanCMSApi.get(`/api/topselling_banner`);
  return response.data[0];
};

const useAdsTopSellingDocumentDetails = (
  id: string,
  options?: UseQueryOptions<TopSellingBanner, DefaultError, TopSellingBanner, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<TopSellingBanner, DefaultError> => {
  return useQuery<TopSellingBanner, DefaultError, TopSellingBanner, QueryKey>(
    {
      queryKey: ["adsTopSellingDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchAdsTopSellingDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

//News get api
const fetchAdsNewsDetails = async (id: string): Promise<any> => {
  const response: any = await eramanCMSApi.get(`/api/news-products-banner-data/all-fields`);
  return response.data[0];
};

const useAdsNewsDocumentDetails = (
  id: string,
  options?: UseQueryOptions<NewsBanner, DefaultError, NewsBanner, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<NewsBanner, DefaultError> => {
  return useQuery<NewsBanner, DefaultError, NewsBanner, QueryKey>(
    {
      queryKey: ["adsNewsDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchAdsNewsDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export {
  useAdsBrandDocumentDetails,
  useAdsNewsDocumentDetails,
  useAdsPromotionDocumentDetails,
  useAdsTopSellingDocumentDetails,
};
